import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { projectDetailsPageEntrypoint } from '@jira/spa-apps__project-settings-details/src/projectDetailsPageEntrypoint.entrypoint.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProjectSettingsResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { classicProjectSettingsDetailsRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/classicProjectSettingsDetailsRoute.tsx';
import { ProjectSettingsDetailsSkeleton } from '@jira/platform__skeletons/src/ui/project-settings/ProjectSettingsFeaturesSkeleton.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import type { Route } from '@atlassian/react-resource-router';

const projectSettingsDetailsPageEntrypoint = createPageEntryPoint({
	main: projectDetailsPageEntrypoint,
});

export const classicProjectSettingsDetailsRouteEntry: Route = createEntry(
	classicProjectSettingsDetailsRoute,
	() => ({
		group: 'project-settings-software',
		skeleton: ProjectSettingsDetailsSkeleton,
		layout: softwareProjectLayout,

		entryPoint: () => projectSettingsDetailsPageEntrypoint,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getNavigationSidebarProjectSettingsResource(),
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
